import React from 'react';
import {View} from 'react-native';

import sy from '~/styles';
import {Dialog, FormNumberInput} from '~/components/controls';

const MarkupDialog = ({value, amount, onDismiss}) => (
  <Dialog
    visible={true}
    title="Toeslag"
    onDismiss={onDismiss}
    buttons={[
      {
        text: 'Sluiten',
        onPress: onDismiss,
      },
    ]}
    options={{noPaddingContent: true}}>
    <View style={[sy['p-4'], sy['gap-4']]}>
      <View>
        <FormNumberInput label="Bedrag toeslag" digits={2} value={value} />
      </View>
      <View>
        <FormNumberInput
          label="Bedrag na toeslag"
          digits={2}
          value={amount + value}
        />
      </View>
    </View>
  </Dialog>
);

export default MarkupDialog;
